// Toggles risk to true
const ADD_RISK_CHECK = 'fulcrum/containers/RiskValidation/ADD_RISK_CHECK'
const ADD_RISK_CHECK_START = 'fulcrum/containers/RiskValidation/ADD_RISK_CHECK_START'
const ADD_RISK_CHECK_SUCCESS = 'fulcrum/containers/RiskValidation/ADD_RISK_CHECK_SUCCESS'
const DISPATCH_ADD_RISK_CHECK = 'fulcrum/containers/RiskValidation/DISPATCH_ADD_RISK_CHECK'

// Toggles risk to false
const REMOVE_RISK_CHECK = 'fulcrum/containers/RiskValidation/REMOVE_RISK_CHECK'
const REMOVE_RISK_CHECK_START = 'fulcrum/containers/RiskValidation/REMOVE_RISK_CHECK_START'
const REMOVE_RISK_CHECK_SUCCESS = 'fulcrum/containers/RiskValidation/REMOVE_RISK_CHECK_SUCCESS'
const DISPATCH_REMOVE_RISK_CHECK = 'fulcrum/containers/RiskValidation/DISPATCH_REMOVE_RISK_CHECK'

// Resets to initial values
const CLEAR_RISK = 'fulcrum/containers/RiskValidation/CLEAR_RISK'

const UPDATE_VALIDATION_VALUE = 'fulcrum/containers/RiskValidation/UPDATE_VALIDATION_VALUE'
const UPDATE_VALUE = 'fulcrum/containers/RiskValidation/UPDATE_VALUE'
const RISK_DEFAULT_VALUE = 'Standard'
const RISK_VALUE = 'Risk'
const STANDARD_VALUE = 'Allowed'

export {
  STANDARD_VALUE,
  UPDATE_VALIDATION_VALUE,
  ADD_RISK_CHECK_START,
  ADD_RISK_CHECK_SUCCESS,
  ADD_RISK_CHECK,
  DISPATCH_ADD_RISK_CHECK,
  REMOVE_RISK_CHECK_START,
  REMOVE_RISK_CHECK_SUCCESS,
  REMOVE_RISK_CHECK,
  DISPATCH_REMOVE_RISK_CHECK,
  CLEAR_RISK,
  UPDATE_VALUE,
  RISK_DEFAULT_VALUE,
  RISK_VALUE,
}
